export default {
  auths: {
    type: Object,
    default: {}
  },
  endpoints: {
    type: Object,
    default: {}
  }
}
